import { camelCase, kebabCase, pascalCase, snakeCase, snakeCaseUpper } from "../helpers/caseHelpers";
import { ICaseConversionService } from "./ICaseConversionService";

export type CaseConverterFn = (name: string) => string;

export interface ICaseConverter {
    id: string;
    name: string;
    convert: CaseConverterFn
}

export class CaseConversionService implements ICaseConversionService {
    getCaseConverters(): ICaseConverter[] {
        return [
            { id: "camelCase", name: "camelCase", convert: camelCase },
            { id: "PascalCase", name: "PascalCase", convert: pascalCase },
            { id: "snake_case", name: "snake_case", convert: snakeCase },
            { id: "SNAKE_CASE", name: "SNAKE_CASE", convert: snakeCaseUpper },
            { id: "kebab-case", name: "kebab-case", convert: kebabCase },
        ];
    }
}